import {AppConfig, BaseAppProps, BaseAppState} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {createTheme, ThemeOptions} from "@mui/material";
import {colorGreen, DEFAULT_THEME_OPTIONS} from "../shared/colors";
import {Main} from "./Main";
import {FIREBASE_CONFIG} from "../consts";
import {ProvisionedApp} from "../shared/ProvisionedApp";
import {ProvisionedAppConfig} from "../shared/types";
import {PathComponent} from "../index";
import "./res/css/App.css";
import {BaseAppPrefs} from "../shared/BaseAppPrefs";
import {AppPrefs} from "./app_prefs";

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

export const COLOR_PRIMARY = "#111";
export const COLOR_SECONDARY = colorGreen;

export const COLOR_BG1 = "#fff";
export const COLOR_BG2 = "#eee";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  typography: {
    h1: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h2: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h3: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h4: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h5: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h6: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    fontSize: 15,
  },
  shape: {
    borderRadius: 24,
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#fff",
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: "#111",
    },
    background: {
      default: COLOR_BG1,
      paper: COLOR_BG2,
    }
  },
};

const THEME = createTheme(THEME_OPTIONS);

export class AppRefs {

  constructor(readonly audio: HTMLAudioElement) {
  }
}

export class App extends ProvisionedApp<AppProps, AppState> {

  private static appRefs: AppRefs;

  static getAppRefs(): AppRefs {
    if (!App.appRefs) {
      App.appRefs = App.createAppRefs();
    }
    return App.appRefs;
  }

  private static createAppRefs() {
    return new AppRefs(document.getElementById("player") as HTMLAudioElement);
  }

  getAppPrefs<T extends BaseAppPrefs>(): T {
    //@ts-ignore
    return AppPrefs.getInstance() as T;
  }

  getProvisionedAppId(): string {
    return "codabot";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return null;
  }

  onCreateAppConfig(): AppConfig {
    return {
      name: "Codabot",
      icon: "/icon.png",
      logo: "/logo192.png",
      stamp: "/stamp.svg",
      loginConfig: {
        noLogin: true,
      },
      theme: THEME,
      firebaseConfig: {options: FIREBASE_CONFIG},
    };
  }

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  protected renderMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
